
import { Component, Mixins, Prop } from "vue-property-decorator";
import { BAIconsMixin, StringsMixin } from '@/mixins';

@Component
export default class CloseButton extends Mixins(BAIconsMixin, StringsMixin) {
	@Prop( {default: undefined }) icon: string;
	@Prop( {default: "Close dialog"} ) tooltip: string;
	@Prop( {default: "black"} ) color: string;

	get Icon(): string {
		if( this.IsEmpty(this.icon) ) return this.BAIcons.closeDialog;
		return this.icon;
	}
	onClick() {
		this.$emit("click");
	}
}
